export default __webpack_public_path__ + "static/media/ChartDashboardOn.6b6f2144.svg";